import api from '@/lib/api';
import type { DebtPaymentRequest } from '@/types/manager.model';

const BASE = '/payments/debt-payments/me';

export interface SubmitDebtPaymentInput {
  amount: number;
  /** Local transfer date/time, format `YYYY-MM-DDTHH:mm` (datetime-local). */
  transferDate: string;
  receipt: File;
  notes?: string;
}

/**
 * Lists the authenticated manager's debt cancellation requests
 * (any status: pending, approved, rejected, cancelled).
 */
export const getMyDebtPayments = async (): Promise<DebtPaymentRequest[]> => {
  const response = await api.get<DebtPaymentRequest[]>(BASE);
  return response.data ?? [];
};

/**
 * Creates a debt cancellation request via bank transfer.
 * Uploads the receipt as multipart; the request starts in PENDING_REVIEW.
 */
export const submitDebtPayment = async (
  input: SubmitDebtPaymentInput,
): Promise<DebtPaymentRequest> => {
  const formData = new FormData();
  formData.append('amount', String(input.amount));
  formData.append('transferDate', input.transferDate);
  formData.append('receipt', input.receipt);
  if (input.notes) {
    formData.append('notes', input.notes);
  }

  const response = await api.post<DebtPaymentRequest>(BASE, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

/**
 * Cancels an own request that is in PENDING_REVIEW → transitions to CANCELLED.
 */
export const cancelDebtPayment = async (
  id: string,
): Promise<DebtPaymentRequest> => {
  const response = await api.delete<DebtPaymentRequest>(`${BASE}/${id}`);
  return response.data;
};
